import { Dispatch, SetStateAction } from 'react';
import { Box, Button, Flex, Switch, Text, ToggleButton, Tooltip } from '@optiaxiom/react';
import { IconBars } from '@optimizely/axiom-icons';

import { styles } from './WorkflowBuilderTopbar.css';

type WorkflowBuilderTopbarProps = {
  onMenuClick?: () => void;
  onSave?: () => void;
  onClose?: () => void;
  title?: string;
  isMenuOpen?: boolean;
  isSaveDisabled?: boolean;
  saveDisabledReason?: string;
  showErrors: boolean;
  setShowErrors: Dispatch<SetStateAction<boolean>>;
  errorCount: number;
};

export function WorkflowBuilderTopbar({
  onMenuClick,
  onSave,
  onClose,
  isMenuOpen,
  title = 'Workflow Builder',
  isSaveDisabled = false,
  saveDisabledReason,
  showErrors,
  setShowErrors,
  errorCount,
}: WorkflowBuilderTopbarProps) {
  return (
    <Flex className={styles.topbar} flexDirection="row" justifyContent="space-between">
      <Flex alignItems="center" justifyContent="center" gap="24" flexDirection="row">
        <Box>
          <ToggleButton
            onClick={onMenuClick}
            aria-label="Menu"
            size="lg"
            pressed={isMenuOpen}
            appearance="default"
            icon={<IconBars />}
          />
        </Box>
        <Flex alignItems="center" gap="8">
          <Text w="full" h="full" size="md" color="fg.default" fontWeight="600">
            {title}
          </Text>
        </Flex>
      </Flex>
      <Flex justifyContent="center" gap="8" flexDirection="row">
        <Switch checked={showErrors} onChange={() => setShowErrors(!showErrors)}>
          <Text fontSize="md" color={errorCount > 0 ? 'fg.default' : 'fg.tertiary'}>
            Debug ({errorCount})
          </Text>
        </Switch>
        <Button onClick={onClose} size="lg" appearance="subtle">
          Close
        </Button>
        <Tooltip content={isSaveDisabled ? saveDisabledReason : ''}>
          <Button onClick={onSave} size="lg" appearance="primary" disabled={isSaveDisabled}>
            Save
          </Button>
        </Tooltip>
      </Flex>
    </Flex>
  );
}
